/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BacksolveBulkRead = {
  readonly id?: number;
  metric?: BacksolveBulkRead.metric | null;
  adjustment_selected?: BacksolveBulkRead.adjustment_selected | null;
  as_of_date?: string | null;
  opm_backsolve_date?: string | null;
};
export namespace BacksolveBulkRead {
  export enum metric {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
  }
  export enum adjustment_selected {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
  }
}

